export default __webpack_public_path__ + "menu-catalog-icon.d679f2475c843a561fd3acccd2437130.svg";